import Content from "./Content";
import ContentFactory from "./ContentFactory";

export default class QuizAnswerContent extends Content {
    constructor(languagePack, contentID, answerText, label) {
        super(QuizAnswerContent.NAME, QuizAnswerContent.TYPE, label, languagePack, contentID, true, false);

        this._answerText = answerText;
        this._isCorrectAnswer = false;
        this._points;
        this.setAnswerText(label);
    }

    remove() {
        this.removeLanguagePackText(QuizAnswerContent.ANSWER_LABEL);
        super.remove();
        this.dispatchEvent("propertyChange");
    }

    clone() {
        let clone;

        clone = QuizAnswerContent(ContentFactory.getContent(QuizAnswerContent.TYPE, this.languagePack));
        clone.contentID = this.contentID;
        clone._answerText = this._answerText;
        clone._isCorrectAnswer = this._isCorrectAnswer;
        clone._points = this._points;
        return clone;
    }

    getAnswerText() {
        return this.getLanguagePackText(QuizAnswerContent.ANSWER_LABEL);
    }

    setAnswerText(value) {
        if (this._answerText !== value) {
            this.setLanguagePackText(QuizAnswerContent.ANSWER_LABEL, value);
            this.dispatchEvent("propertyChange");
        }
    }

    getAnswerText() {
        return this.getLanguagePackText(QuizAnswerContent.ANSWER_LABEL);
    }

    setPoints(points) {
        this._points = points;
    }

    setIsCorrectAnswer(correct) {
        this._isCorrectAnswer = correct;
    }

    getIsCorrectAnswer(correct) {
        return this._isCorrectAnswer;
    }

    convertToObject() {
        return this.getObject(["isCorrectAnswer", "points"]);
    }
}

QuizAnswerContent.NAME = "Quiz Answer";
QuizAnswerContent.TYPE = "engQuizAnswerContent";
QuizAnswerContent.ANSWER_LABEL = "answer text";
